import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class NavBar extends Component {

    calculateRegions() {
        var lastCheckpoint = null;

        for (let checkpointId in this.state.checkpoints) {
            if (this.state.checkpoints.hasOwnProperty(checkpointId)) {
                var checkpoint = this.state.checkpoints[checkpointId];
                var $element = $('#' + checkpointId);
                // DOM not ready yet
                if (!$element.length) {
                    return;
                }
                if (lastCheckpoint !== null) {
                    var top = $element.offset().top;
                    checkpoint.top = top - 20;
                    lastCheckpoint.bottom = top - 20;
                } else {
                    checkpoint.top = 0;
                }
                lastCheckpoint = checkpoint;
            }
        };
        lastCheckpoint.bottom = $(document).height() + 1;
    }

    handleResize() {
        const that = this;
        setTimeout(function() {
            that.calculateRegions();
            that.setState({});
        }, 250);
    }

    handleScroll() {
        var that = this;
        var currentScrollY = window.scrollY;

        if (!this.state.scrollRequestAnimationFrameFuncRunning) {
            window.requestAnimationFrame(function() {
                for (let checkpointId in that.state.checkpoints) {
                    if (that.state.checkpoints.hasOwnProperty(checkpointId)) {
                        var checkpoint = that.state.checkpoints[checkpointId];

                        if (checkpoint.top === null) {
                           that.calculateRegions();
                        }
                    }
                }
                that.setState({
                    currentScrollY: currentScrollY,
                    scrollRequestAnimationFrameFuncRunning: false
                });
            });
        }
        that.setState({
            scrollRequestAnimationFrameFuncRunning: true
        });
    }

    state = {
        checkpoints: {
            'overview-section-card': {
                top: null,
                bottom: null,
            },
            'inventory-label': {
                top: null,
                bottom: null,
            },
            'ordering-label': {
                top: null,
                bottom: null,
            },
            'sales-label': {
                top: null,
                bottom: null,
            },
            'efficiency-section-card': {
                top: null,
                bottom: null,
            },
            'pour-cost-section-card': {
                top: null,
                bottom: null,
            },
            'next-steps-wrapper': {
                top: null,
                bottom: null,
            },
        },
        currentScrollY: 0,
        // Don't change this bool
        // it's flipped back and forth in
        // handle scroll to utilize
        // requestAnimationFrame
        scrollRequestAnimationFrameFuncRunning: false,
        thisHandleScroll: this.handleScroll.bind(this),
        thisHandleResize: this.handleResize.bind(this)
    };

    componentDidMount() {
        window.addEventListener('scroll', this.state.thisHandleScroll);
        window.addEventListener('resize', this.state.thisHandleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.state.thisHandleScroll);
        window.removeEventListener('resize', this.state.thisHandleResize);
    }

    getSideNavListAnchorElement(id, text) {

        let activeStateClass;
        if (this.state.checkpoints[id].bottom < this.state.currentScrollY) {
            activeStateClass = ' before-active-checkpoint ';
        } else if (this.state.checkpoints[id].top < this.state.currentScrollY && this.state.checkpoints[id].bottom > this.state.currentScrollY) {
            activeStateClass = ' active-checkpoint ';
        }

        return (
            <li key={ id }>
                <a href={ "#" + id } className={ activeStateClass }>{ text }</a>
            </li>
        );
    }

    render() {
        const { dataId } = this.props;

        return (
            <div className="bar-profit-side-nav">
                <div className="bar-profit-title-logo">
                    <div className="logo-wrapper">
                        <a className="brand-logo transition" href="https://www.bevspot.com" target="_blank">
                            <span className="bevicon bevico-bevspot-logo transition"></span>
                            <span className="bevicon bevico-logo-text transition"></span>
                        </a>
                        <h1 className="bar-profit-logo">
                            <div className="top-rule"></div>
                            <div className="top-rule second-top-rule"></div>
                            Bar Profit Analysis
                        </h1>
                    </div>
                </div>
                <ul>
                    { this.getSideNavListAnchorElement('overview-section-card', 'Overview') }

                    <li className="nav-divider">Industry Benchmarks</li>

                    { this.getSideNavListAnchorElement('inventory-label', 'Inventory') }

                    { this.getSideNavListAnchorElement('ordering-label', 'Usage') }

                    { this.getSideNavListAnchorElement('sales-label', 'Sales') }

                    <li className="nav-divider">Key Performance Indicators</li>

                    { this.getSideNavListAnchorElement('efficiency-section-card', 'Inventory Efficiency') }

                    { this.getSideNavListAnchorElement('pour-cost-section-card', 'Pour Cost') }

                    <li className="nav-divider">Recommendations</li>

                    { this.getSideNavListAnchorElement('next-steps-wrapper', 'Optimize Your Bar') }
                </ul>

                <div className="bar-profit-social-share">
                    <a
                        href="https://www.facebook.com/sharer/sharer.php?u=http%3A//hubs.ly/H04hN360"
                        target="_blank"
                    >
                        <span className="bevicon bevico-social-facebook">
                        </span>
                    </a>
                    <a
                        href="https://www.linkedin.com/shareArticle?mini=true&url=http%3A//hubs.ly/H04hNzG0&title=&summary=&source="
                        target="_blank"
                    >
                        <span className="bevicon bevico-social-linkedin">
                        </span>
                    </a>
                    <a
                        href="https://twitter.com/home?status=I%20just%20graded%20my%20beverage%20program%20on%20%40BevSpot%27s%20Bar%20Profit%20Analysis%20Tool.%20How%20does%20yours%20compare?%20http%3A//hubs.ly/H04hNBw0"
                        target="_blank"
                    >
                        <span className="bevicon bevico-twitter">
                        </span>
                    </a>
                    <a
                        href={ "mailto:?&subject=I just graded my bar with BevSpot—see how I scored&body=I%20used%20BevSpot's%20new%20Bar%20Profit%20Analysis%20Tool%20to%20grade%20my%20beverage%20program.%20%0A%0ACheck%20out%20my%20score%20here%20(%20https%3A//app.bevspot.com/bar-profit-tool/?data-id=" + this.props.dataId + "%20).%20You%20can%20see%20how%20my%20inventory%20efficiency%20levels%20and%20pour%20costs%20compare%20to%20other%20bars%20and%20restaurants%20across%20the%20industry.%0A%0AWant%20to%20see%20your%20score?%20Take%20a%20look%3A%20app.bevspot.com/bar-profit-tool/" }
                        target="_blank"
                    >
                        <span className="bevicon bevico-email"></span>
                    </a>
                </div>
            </div>
        );
    }
}

NavBar.propTypes = {
    dataId: PropTypes.string.isRequired,
};

export default NavBar;